import { PropertyConfig, PropertyOptionsAll } from "@cervval.js/common/src/forms/propertyConfig";
import { PropertyConfigType } from "@cervval.js/common/src/forms/propertyConfig.types";
import { MinLengthValidator } from "@cervval.js/common/src/services/validation.impl/validators/minLength.validator";
import { RequiredValidator } from "@cervval.js/common/src/services/validation.impl/validators/required.validator";
import { validatorEntry } from "@cervval.js/common/src/services/validation.impl/validators/validator";
import { BookingDataSourceUID } from "../booking.ds";
import { BookingCommonUser } from "../booking.dto";
import { I18nProfileBooking } from "./profileBooking.i18n";

export const sortedBookingUserDTOKeys: (keyof BookingCommonUser)[] = ["givenName", "familyName", "autoAccept", "advertisement"];

/** Export BookingUser as PropertyConfig */
export function exportBookingUserDTOToPropertyConfig(): PropertyConfig[] {
    const i18n = I18nProfileBooking();
    const propertyConfigs: PropertyConfig[] = [];
    sortedBookingUserDTOKeys.forEach((key) => {
        let propertyConfig = {} as PropertyConfig<PropertyConfigType, PropertyOptionsAll>;
        const comp = propertyConfig;
        switch (key) {
            case "familyName":
                propertyConfig = {
                    label: i18n.familyName.label,
                    propertyName: key,
                    typeUid: PropertyConfigType.STRING,
                    options: {
                        placeholder: i18n.familyName.optionsPlaceholder
                    },
                    validators: {
                        ...validatorEntry(RequiredValidator, true),
                        ...validatorEntry(MinLengthValidator, 3)
                    }
                };
                break;
            case "givenName":
                propertyConfig = {
                    label: i18n.givenName.label,
                    propertyName: key,
                    typeUid: PropertyConfigType.STRING,
                    options: {
                        placeholder: i18n.givenName.optionsPlaceholder
                    },
                    validators: {
                        ...validatorEntry(RequiredValidator, true),
                        ...validatorEntry(MinLengthValidator, 3)
                    }
                };
                break;
            case "autoAccept":
                {
                    propertyConfig = {
                        label: i18n.autoAccept.label,
                        propertyName: key,
                        typeUid: PropertyConfigType.SWITCH

                    };
                    break;
                }
            case "advertisement":
                {
                    propertyConfig = {
                        label: i18n.advertisement.label,
                        propertyName: key,
                        typeUid: PropertyConfigType.LISTSELECT,
                        options: {
                            itemList: BookingDataSourceUID.ADVERTISEMENT
                        }

                    };
                    break;
                }
            default:
                break;
        }
        if (propertyConfig !== comp) {
            propertyConfigs.push(propertyConfig);
        }
    });
    return propertyConfigs;
}